import Sentry from 'Integrations/Sentry';

export const shouldLogToVendor = () => {
  switch (process.env.REACT_APP_STAGE) {
    case 'development-minified':
    case 'prod':
    case 'staging':
    case 'integration':
      return true;
    default:
    case 'development':
      return false;
  }
};

// conditional chaining to fix null state
// must be wrapped in try catch to prevent breaking dev env

export const getUICommitHash = () => {
  try {
    if (typeof process !== 'undefined' && process.env.REACT_APP_COMMIT_HASH) {
      return process.env.REACT_APP_COMMIT_HASH;
    }
  } catch (e) {
    Sentry.createSentryErrorLog(e);
    return null;
  }
  return null;
};
